import {
  AutoBranchMindCondition,
  AutoBranchMindConditionForm,
  SearchParams,
} from 'types/auto_branch_mind_condition'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'auto_branch_mind_conditions'

export const requests = {
  fetchAutoBranchMindConditons: async (
    page: number,
    limit: number,
    searchParams?: SearchParams,
  ) => {
    return axiosForGigbaseBiz.get<DataResponse<AutoBranchMindCondition[]>>(
      resource,
      {
        params: {
          page,
          limit,
          job_id: searchParams?.job_id,
          occupation_id: searchParams?.occupation_id,
        },
      },
    )
  },
  create: async (form: AutoBranchMindConditionForm) => {
    return axiosForGigbaseBiz.post<DataResponse>(resource, form)
  },
  update: async (id: string, form: AutoBranchMindConditionForm) => {
    return axiosForGigbaseBiz.patch<DataResponse<AutoBranchMindCondition>>(
      mergeURL(resource, id.toString()),
      form,
    )
  },
  delete: async (id: string) => {
    return axiosForGigbaseBiz.delete<DataResponse>(
      mergeURL(resource, id.toString()),
    )
  },
}
